import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { CustomField, CustomFieldTypeName } from '../custom-fields.model';
import { ValueAndLabel } from 'src/app/shared/components/select-ionic/select-ionic.component';

@Component({
  selector: 'app-custom-field',
  templateUrl: './custom-field.component.html',
  styleUrls: ['./custom-field.component.scss'],
})
export class CustomFieldComponent implements OnInit {
  CustomFieldTypeName = CustomFieldTypeName;

  @Input() customField: CustomField;
  @Input() customFieldFormGroup?: FormGroup; // a form group with a 'formValue' subcontrol

  optionsForSelect: ValueAndLabel<string>[];

  constructor() {}

  ngOnInit() {
    if (
      [CustomFieldTypeName.Enumerate, CustomFieldTypeName.Multipicklist].includes(this.customField.definition.type.type)
    ) {
      this.buildSelectOptions();
    }
  }

  private buildSelectOptions() {
    this.optionsForSelect = this.customField.definition.type.allowed.map(allowed => ({
      value: allowed.id,
      label: allowed.label,
    }));
  }
}
